/* eslint-disable prettier/prettier */
import Loader from "common/Loader";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { Accordion, AccordionTab } from "primereact/accordion";
import { FunctionComponent, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import InvestorService from "services/invoice-service";
import { InputSwitch } from "primereact/inputswitch";
import { OverlayPanel } from "primereact/overlaypanel";
import VIewInvestorProdCodes from "./ViewInvestorProdCodes";
import ViewPackages from "./ViewPackages";
import AdminServices from "services/admin-services";
import { handlingUrlParams } from "Utils/AppUtils";
import { Sidebar } from "primereact/sidebar";
import AddInvestor from "./AddInvestor";
import CustomerService from "services/customer-service";
import TokenService from "services/TokenService";

const ViewInvestorByID: FunctionComponent = () => {
  const navigate = useNavigate();
  const pullCriteriaOp = useRef<OverlayPanel>(null);
  const { id } = useParams();
  const [activeAccordionIndex, setActiveAccordionIndex] = useState<
    number | null
  >(null);
  const [showInvestor, setShowInvestor] = useState<boolean>(false);

  const [packageList, setPackageList] = useState([]);
  const [packageData, setPackageData] = useState<any>(null);
  const op = useRef<OverlayPanel>(null);
  const [investorDetails, setInvestorDetails] = useState<any | undefined>(
    undefined,
  );
  // eslint-disable-next-line no-unused-vars
  const [, setCustomerApplication] = useState<any | null>(null);
  const [basicConfiguration, setBasicConfiguration] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const loadLazyData = () => {
    if (!id) return;
    setLoading(true);
    InvestorService.getInvestorsListByID(Number(id))
      .then(async (response: any) => {
        console.log("Investor details:", response);
        const matchedInvestor = response?.data || null;

        // if (!matchedInvestor?.id) {
        //   setInvestorDetails(undefined);
        //   setLoading(false);
        //   return;
        // }

        setInvestorDetails(matchedInvestor);
        await getPackages(matchedInvestor?.id);
        await getPackagesByID(matchedInvestor?.id);
      })
      .catch((e: Error) => {
        console.warn(e);
        setLoading(false);
      });
  };

  useEffect(() => {
    loadLazyData();
    getCustomerApplication();
  }, [id]);

  const pullCriteria = (rowData: any) => {
    const pull = rowData?.pullCriteria;
    const raw = pull?.searchCriteria;

    if (!pull) return <>N/A</>;

    let parsedData: any;

    try {
      if (raw) {
        try {
          parsedData = JSON.parse(raw);
        } catch {
          const safeJson = raw.replace(
            /@@investorlist@@/gi,
            '"@@InvestorList@@"',
          );
          parsedData = JSON.parse(safeJson);
        }
      }
    } catch (e) {
      console.error("Invalid searchCriteria JSON:", raw);
      return <>Invalid criteria</>;
    }

    const fields: string[] = parsedData?.fields || [];
    const filters: any[] = parsedData?.filter?.terms || [];

    return (
      <div
        className="text-sm leading-relaxed max-w-md"
        style={{ minHeight: 120 }}
      >
        <div className="mb-2">
          <div className="font-semibold">{pull.name}</div>
          {pull.description && (
            <div className="text-gray-600">{pull.description}</div>
          )}
        </div>

        <>
          {fields.length > 0 && (
            <div className="mb-2">
              <strong>Fields:</strong>
              <ul className="list-disc list-inside">
                {fields.map((field, idx) => (
                  <li key={idx}>{field}</li>
                ))}
              </ul>
            </div>
          )}

          {filters.length > 0 && (
            <div>
              <strong>Filters:</strong>
              <ul className="list-disc list-inside">
                {filters.map((term, idx) => {
                  let valueLabel = "—";

                  if (term.matchType === "IsEmpty") valueLabel = "is empty";
                  else if (term.matchType === "MultiValue")
                    valueLabel = "@@InvestorList@@";
                  else if (term.value)
                    valueLabel = Array.isArray(term.value)
                      ? term.value.join(", ")
                      : term.value;

                  return (
                    <li key={idx}>
                      <span className="font-medium">{term.canonicalName}</span>{" "}
                      <span className="text-gray-500">({term.matchType})</span>:{" "}
                      {valueLabel}
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
        </>
      </div>
    );
  };

  const getPackages = (investorId: string) => {
    op.current?.hide();
    setLoading(true);
    InvestorService.getInvestorsPackage(investorId)
      .then((response: any) => {
        setPackageData(response?.data);
         setLoading(false);
      })
      .catch((e: Error) => {
        console.log(e);
        setLoading(false);
      });
  };

  const getPackagesByID = (investorId?: number) => {
    AdminServices.getInvestorPackagesNew(
      handlingUrlParams({ investorId: investorId }),
    )
      .then((response: any) => {
        const packages = (response?.data || []).map((pkg: any) => ({
          label: pkg?.package?.name,
          value: Number(pkg?.package?.id ?? pkg?.packageId ?? pkg?.id ?? 0),
          investorPackageId: pkg.id,
          packageData: pkg,
        }));

        setPackageList(packages);
        setLoading(false);

      })
      .catch((e: Error) => {
        console.log(e);
        setLoading(false);

      });
  };

  const getCustomerApplication = () => {
    const customerData = TokenService.getCustomerData();
    const customerId = customerData?.[0]?.id;

    if (!customerId) {
      console.warn("No customer ID found in user data");
      return;
    }

    const applicationId = 5;

    CustomerService.getCustomerApplications(customerId, applicationId)
      .then((response: any) => {
        const firstRecord = response?.data?.[0] || null;
        setCustomerApplication(firstRecord);
        
        // Parse basicConfiguration if it's a string
        if (firstRecord?.basicConfiguration) {
          try {
            const config = typeof firstRecord.basicConfiguration === 'string' 
              ? JSON.parse(firstRecord.basicConfiguration) 
              : firstRecord.basicConfiguration;
            setBasicConfiguration(config);
            console.log("Basic Configuration:", config);
          } catch (e) {
            console.warn("Error parsing basicConfiguration:", e);
          }
        }
        console.log("Customer Application:", firstRecord);
      })
      .catch((e: Error) => {
        console.warn("Error fetching customer application:", e);
      });
  };

  return (
    <>
      <>
        <div className="flex items-center gap-3 mb-4">
          <Button
            icon="pi pi-arrow-left"
            className="p-button-text p-button-sm"
            onClick={() => navigate("/investor")}
            tooltip="Back to Investors"
            tooltipOptions={{ position: "right" }}
          />
          <h3 className="text-2xl font-semibold">Manage Investor</h3>
        </div>

        {loading && <Loader />}

        {!loading && investorDetails && (
          <Card
            className="shadow-md rounded-lg"
            header={
              <div className="flex justify-between items-center p-4 border-b">
                <div>
                  <span className="text-lg font-semibold">
                    {investorDetails?.name}
                  </span>
                  <i
                    className="pi pi-info-circle mx-2 text-blue-500 cursor-pointer"
                    onClick={(e) => op?.current?.toggle(e)}
                  />
                  <OverlayPanel ref={op}>
                    <p>{investorDetails?.description}</p>
                  </OverlayPanel>
                </div>
                <Button
                  label="Edit"
                  icon="pi pi-pencil"
                  className="p-button-sm p-button-outlined p-button-success"
                  onClick={() => {
                    setShowInvestor(true);
                  }}
                />
              </div>
            }
          >
            <div className="grid grid-cols-5 gap-4 text-sm font-medium text-gray-600 border-b pb-2">
              {/* <div>Name</div> */}
              {investorDetails?.pullCriteria && <div>Pull Criteria</div>}
              <div>External Investor Name</div>
              <div>Enable Classification</div>
              <div>Active</div>
              <div>Is Bond Investor</div>
            </div>

            <div className="grid grid-cols-5 gap-4 py-3 items-center">
              {/* <div>{investorDetails?.name}</div>*/}
              {investorDetails?.pullCriteria && (
                <div className="flex flex-row items-center">
                  <span>{investorDetails?.pullCriteria?.name} </span>

                  <i
                    className="pi pi-info-circle mx-2 text-blue-500 cursor-pointer"
                    onClick={(e) => pullCriteriaOp.current?.toggle(e)}
                  />
                </div>
              )}
              <div>{investorDetails?.externalInvestorName}</div>

              <div className="flex items-center gap-2">
                <InputSwitch
                  checked={!!investorDetails?.enableClassification}
                  disabled
                />
                <span className="text-sm font-medium">
                  {investorDetails?.enableClassification ? "Yes" : "No"}
                </span>
              </div>

              <div className="flex items-center gap-2">
                <InputSwitch checked={!!investorDetails?.isActive} disabled />
                <span className="text-sm font-medium">
                  {investorDetails?.isActive ? "Yes" : "No"}
                </span>
              </div>

              <div className="flex items-center gap-2">
                <InputSwitch
                  checked={!!investorDetails?.isBondInvestor}
                  disabled
                />
                <span className="text-sm font-medium">
                  {investorDetails?.isBondInvestor ? "Yes" : "No"}
                </span>
              </div>
            </div>
          </Card>
        )}

        <div className="mt-4">
          <Accordion
            activeIndex={activeAccordionIndex}
            onTabChange={(e) => setActiveAccordionIndex(e.index)}
          >
            {investorDetails?.isBondInvestor && (
              <AccordionTab header={"Product Codes"}>
                <div className="py-5">
                  <VIewInvestorProdCodes
                    selectedInvestor={investorDetails}
                    onSaveSuccess={loadLazyData}
                  />
                </div>
              </AccordionTab>
            )}
          </Accordion>

          <ViewPackages
            data={packageData}
            packageList={packageList}
            selectedInvestor={investorDetails}
            refreshPackages={() => getPackages(investorDetails?.id)}
            basicConfiguration={basicConfiguration}
          />
        </div>

        {!loading && !investorDetails && (
          <p className="text-gray-500">No Investor Found</p>
        )}

        <Sidebar
          style={{ width: 500 }}
          visible={showInvestor}
          onHide={() => setShowInvestor(false)}
          position="right"
        >
          <AddInvestor
            mode="edit"
            investorDetails={investorDetails}
            onHide={() => setShowInvestor(false)}
            onSuccess={() => {
              loadLazyData();
            }}
          />
        </Sidebar>
        <OverlayPanel ref={pullCriteriaOp} style={{ width: 400 }}>
          {investorDetails?.pullCriteria ? (
            pullCriteria(investorDetails)
          ) : (
            <p className="text-gray-500">No criteria available</p>
          )}
        </OverlayPanel>
      </>
    </>
  );
};

export default ViewInvestorByID;
